<template>
  <div id="AddVehicle" class="AddVehicle">
    <QS-h4-title title="车辆选择" />
    <div class="addVehicleBox">
      <form-text-box
        ref="vehicleSelection"
        :dataList="m_addVehicle"
        :model="m_addVehicleModel"
      />
      <el-button @click="addCar" class="button" type="primary" size='small'>添加</el-button>
    </div>
    <QS-h4-title v-if="showBatch" no-decorate>
      <template slot="right">
        <el-button class='float-btn' type='text' size='small'
          ><a :href='addCarTemplate'>批量添加车辆模板下载</a>
        </el-button>
        <el-upload
          class='float-btn'
          action=''
          :http-request='uploadRequest'
          :limit='1'
          :autoUpload='true'
          :file-list='fileList1'
          :show-file-list='false'
          :disabled='loading.upload'
        >
          <el-button :loading='loading.upload' size='small'>批量添加车辆</el-button>
        </el-upload>
      </template>
    </QS-h4-title>
    <el-table :data='addVehicleTable' height='300' border style='width: 100%'>
      <el-table-column
        type='index'
        label='序号'
        width='80'
      ></el-table-column>
      <el-table-column
        prop='id'
        label='车辆ID'
        width='100'
      ></el-table-column>
      <el-table-column
        prop='brandName'
        label='品牌'
        min-width='100'
      ></el-table-column>
      <el-table-column
        prop='seriesName'
        label='车系'
        min-width='100'
      ></el-table-column>
      <el-table-column
        prop='modelName'
        label='车型'
        min-width='100'
      ></el-table-column>
      <el-table-column
        prop='plateNo'
        label='车牌号'
        min-width='100'
      ></el-table-column>
      <el-table-column
        prop='carStateName'
        label='车辆状态'
        min-width='100'
      ></el-table-column>
      <el-table-column
        prop='inventoryStateName'
        label='库存状态'
        min-width='100'
      ></el-table-column>
      <el-table-column fixed='right' label='操作' width='100' flexd="right">
        <template slot-scope='scope'>
          <el-button
            type='text'
            size='small'
            style='margin-left: 0 !important'
            @click='dataDelete(scope.$index)'
          >删除
          </el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 导入失败-弹窗 -->
    <dialogWrap
      v-model='uploadDialogShow'
      title='导入失败提示'
      :width="'750px'"

      class='spring-frame'
      :before-close='beforeUploadClose'
    >
      <p
        v-for='(item, index) in uploadTableData'
        :key='index'
        style='margin-bottom: 8px'
      >
        {{ item }}
      </p>
    </dialogWrap>
  </div>
</template>
<script>
import { FuzzySearch, leaseOrderCarImport } from '@/api/purchaseAndSaleAPI'
import { addCarTemplate } from '@/config'
import axios from 'axios'
import { getHead } from '@/utils'

export default {
  data() {
    return {
      addCarTemplate,
      loading: {
        upload: false,
      },
      fileList1: [],
      // eslint-disable-next-line vue/no-unused-properties
      currentPlateNoId: '',
      uploadDialogShow: false, // 导入失败弹窗
      uploadTableData: [], // 导入失败数据
      carList: [], // 车辆列表
    }
  },
  props: {
    addVehicleTable: {
      type: Array,
      default: () => [],
    },
    m_addVehicle: {
      type: Array,
      default: () => [],
    },
    m_addVehicleModel: {
      type: Object,
      default: () => ({}),
    },
    // 最大可添加车辆数
    maxVehicle: {
      type: Number,
      default: -1,
    },
    // 批量功能是否展示
    showBatch: {
      type: Boolean,
      default: true,
    },
    // 租赁方案id
    planId: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    'm_addVehicleModel.brandSeriesModel': {
      handler(val) {
        const { brandId, seriesId, modelId } = val
        /* eslint-disable vue/no-mutating-props */
        this.m_addVehicleModel.brandId = brandId
        this.m_addVehicleModel.seriesId = seriesId
        this.m_addVehicleModel.modelId = modelId
        if (modelId) {
          this.plateNoRemoteMethod()
        }
      },
      deep: true,
    },
    planId(val) {
      // 租赁方案变化时，品牌车系车型组件置灰或取消置灰
      const disabled = !!val
      this.$refs.vehicleSelection?.setItemData({ elConfigKey: 'disabled', key: 'brandSeriesModel', data: disabled })
      this.$refs.vehicleSelection?.setItemData({ elConfigKey: 'brandSeriesModelName', key: 'brandSeriesModel', data: this.m_addVehicleModel.brandSeriesModelName })
    },
  },
  methods: {
    // 删除
    dataDelete(index) {
      // eslint-disable-next-line vue/no-mutating-props
      this.addVehicleTable.splice(index, 1)
    },
    beforeUploadClose() {
      this.uploadTableData = []
      this.uploadDialogShow = false
    },
    // 添加
    addCar() {
      if (this.maxVehicle !== -1 && this.addVehicleTable.length >= this.maxVehicle) {
        this.$message.error(`只允许添加${this.maxVehicle}辆车`)
        return
      }

      const { plateNo } = this.m_addVehicleModel
      if (!plateNo) {
        this.$message.error('请先选择车型和车辆')
        return
      }
      this.carList.forEach((item) => {
        if (Number(item.id) === Number(plateNo)) {
          if (this.addVehicleTable.filter((dataItem) => Number(dataItem.id) === Number(plateNo)).length) {
            this.$message.error('该车辆已添加')
            return
          }
          // eslint-disable-next-line vue/no-mutating-props
          this.addVehicleTable.push(item)
        }
      })
    },

    // 处理上传结果
    processUploadResult(data) {
      if (data && data.orderCarInfos && data.orderCarInfos.length > 0) {
        // 已添加车辆id集合
        const carIds = this.addVehicleTable.map((item) => item.id)
        // 上传车辆数据与已添加车辆重合id集合
        const tempCarIds = []
        data.orderCarInfos.forEach((item) => {
          if (carIds.includes(item.id)) {
            tempCarIds.push(item.id)
          }
        })
        if (tempCarIds.length > 0) {
          // 错误信息处理，只要有重复数据就不能添加
          const exportErrorMegs = []
          this.addVehicleTable.forEach((item, index) => {
            if (tempCarIds.includes(item.id)) {
              exportErrorMegs.push(`第${index + 1}行：本订单已存在该车辆，请勿重复添加`)
            }
          })
          this.uploadTableData = exportErrorMegs
          this.uploadDialogShow = true
          return
        }
        this.$message({
          message: '导入成功',
          type: 'success',
        })
        // eslint-disable-next-line vue/no-mutating-props
        this.addVehicleTable.push(...data.orderCarInfos)
      }
      if (data && data.exportErrorMegs && data.exportErrorMegs.length > 0) {
        this.uploadTableData = data.exportErrorMegs || []
        this.uploadDialogShow = true
      }
    },

    // 上传
    uploadRequest({ file }) {
      this.loading.upload = true
      const formData = new FormData()
      formData.append('file', file)
      formData.append('group', 'order')
      formData.append('code', 'order_vehicle_file')
      axios({
        url: '/admin/v1/vehicle/fs/standard/upload',
        method: 'POST',
        data: formData,
        headers: {
          ...this.headers,
          ...getHead(this.$store),
        },
        onUploadProgress: ({
          loaded,
          total,
        }) => {
          this.isProgress = true
          this.disabled = true
          this.uploadPercent = parseInt(loaded / total)
        },
      }).then(({
        data: {
          code,
          data,
          msg,
        },
      }) => {
        if (code === 1) {
          try {
            leaseOrderCarImport({
              fileAddress: data,
            })
              .then((res) => {
                if (res.code === 1) {
                  this.processUploadResult(res.data)
                }
                this.loading.upload = false
              })
              .catch((error) => {
                if (error.data !== null) {
                  this.ImportShow = true
                  this.ImportText = error.data
                }
                this.loading.upload = false
              })
            this.fileList1 = []
          } catch (error) {
            this.fileList1 = []
            this.loading.upload = false
          }
        } else {
          this.fileList1 = []
          this.loading.upload = false
          this.$message.error(msg)
        }
      }).finally(() => {
        this.loading.upload = false
      })
    },
    // 车辆模糊搜索
    // eslint-disable-next-line vue/no-unused-properties
    plateNoRemoteMethod() {
      // eslint-disable-next-line vue/no-mutating-props
      this.m_addVehicleModel.plateNo = '' // 清空车辆
      FuzzySearch({
        plateNo: '',
        state: 3,
        modelId: this.m_addVehicleModel.modelId,
        deptId: this.$route.query.deptId,
      }).then((res) => {
        const { code, data } = res
        if (code === 1) {
          this.carList = data
          this.$refs.vehicleSelection.setItemData({ elConfigKey: 'list', key: 'plateNo', data })
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.AddVehicle {
  .addVehicleBox {
    display: flex;
    .button {
      height: 32px;
    }
  }
  ::v-deep .el-form-item {
    width: 390px !important;
  }
}
#AddVehicle {
  ::v-deep .el-table tbody td {
    border-bottom: solid 0px #EBEDF0 !important;
  }
}
</style>

